module.exports = "/_next/static/images/Commercial-Solutions-8f7552e6f83de584dd7780cca3afdf36.jpg";